import React, { FC, useEffect } from "react";
import { DateTime } from "luxon";
import {
  Button,
  Grid,
  Typography,
  Select,
  MenuItem,
  CircularProgress,
  IconButton,
  Snackbar,
  SnackbarContent,
  OutlinedInput,
  Table,
  TableCell,
  TableRow,
} from "@material-ui/core";

import Avatar from "@material-ui/core/Avatar";
import { green, red } from "@material-ui/core/colors";
import RadioButtonUnchecked from "@material-ui/icons/RadioButtonUnchecked";
import CloseIcon from "@material-ui/icons/Close";
import { VerticalAlignTop, VerticalAlignBottom } from "@material-ui/icons";
import { getFirstFlg, getFixedFlg, getReadFixedFlg} from "../../Header/Header";
import DatePicker from "../../common/DatePicker";
import KeieiShindanModalManual from "./KeieiShindanModalManual";
import {
  getKeieiShindanData,
  updateKeieiShindanFirestore,
  KEIEI_SHINDAN_OTHER_DATA,
  getKeieiShindanRecordsFirestoreData,
} from "./KeieiShindanDataOperation";
import { makeStyles } from "@material-ui/core/styles";
import { userLogging } from "../../../apis/userLog";
import KeieiShindanDialog from "../KeieiShindanDialog";
import { useSelector } from "react-redux";
import { selectUser } from "../../../features/userSlice";
import { getJobCategoryFromCode } from "../../../apis/privilege";
import { postRequest } from "../../../apis/axiosAction";

const useStyles = makeStyles({
  contentFrame: {
    overflowY: "auto",
    height: "68vh",
    // iPad縦
    "@media (min-width: 1000px)": {
      height: "68vh",
    },
    // iPad横
    "@media (min-width: 1150px)": {
      height: "68vh",
    },
    // GWPC
    "@media (min-width: 1300px)": {
      height: "65vh",
    },
  },
  gray: {
    color: "#c0c0c0",
    backgroundColor: "#e6e6e6",
  },
  mark: {
    color: "#fff",
    backgroundColor: green[500],
    boxShadow: "0px 0px 0px 3px #000 inset",
  },
  ngMark: {
    color: "#fff",
    backgroundColor: red[500],
    boxShadow: "0px 0px 0px 3px #000 inset",
  },
  green: {
    color: "#fff",
    backgroundColor: green[500],
  },
  red: {
    color: "#fff",
    backgroundColor: red[500],
  },
  columnData: {
    color: "#3e3e3e",
    backgroundColor: "#ffffff",
    margin: "2px",
  },
  header: {
    paddingTop: "15px",
    paddingLeft: "15px",
    marginLeft: "0px",
    marginBottom: "10px",
    backgroundColor: "#ffffff",
  },
  buttonSpace: {
    paddingRight: "15px",
  },
  tabBase: {
    backgroundColor: "#d9d9d9",
    padding: "2px",
  },
  columnHeader: {
    color: "white",
    outlineColor: "#3e3e3e",
    backgroundColor: "#4dc0b2",
    margin: "2px",
  },
  autoColumnResult: {
    color: "#3e3e3e",
    backgroundColor: "#ececec",
    verticalAlign: "middle",
    margin: "2px",
  },
  columnResult: {
    color: "#3e3e3e",
    backgroundColor: "#d8e8e6",
    verticalAlign: "middle",
    margin: "2px",
  },
  columnHeight: {
    minHeight: "9vh",
  },
  headerHeight: {
    height: "7vh",
  },
  footer: {
    paddingTop: "8px",
  },

  tableCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
  },
  inputTableCell: {
    paddingTop: "0",
    paddingBottom: "0",
    border: "1px solid #aaa",
    height: "65px",
  },
  tableHeader: {
    color: "white",
    backgroundColor: "#4dc0b2",
    textAlign: "center",
  },
  weekHeader: {
    color: "white",
    backgroundColor: "#e3bc52",
    textAlign: "center",
  },
  overLayer: {
    position: "fixed",
    width: "100%",
    height: "100%",
    top: "0",
    left: "0",
    backgroundColor: "#CCC",
    opacity: "0.5",
    zIndex: 100000,
  },
  circularProgress: {
    position: "absolute",
    top: "35%",
    left: "45%",
    opacity: "0.8",
    color: "#ccc",
  },
  upDownButton: {
    color: "white",
    backgroundColor: "#ef942a",
    "&:hover": {
      backgroundColor: "#e38511",
    },
    marginRight: "1vw",
  },
});

// 画面項目の変更フラグ
let changeFlg = false;
export function getChangeFlg() {
  return changeFlg;
}
export function setChangeFlg(flg: boolean) {
  changeFlg = flg;
}

// 曜日の取得
const getDayOfWeekText = (datetime: DateTime | null) => {
  if (!datetime) {
    return;
  }
  let weekDayArray: string[] = [];
  weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
  const dayOfWeek = datetime.weekday;
  return weekDayArray[dayOfWeek - 1];
};

// 作成日付(旧承認日)
let isApprove: number = 0;
export function isApproveDate() {
  return isApprove;
}
function checkApproveDate(dayStr: string | null, lastApproveDay: string) {
  isApprove =
    lastApproveDay !== ""
      ? dayStr && DateTime.fromFormat(dayStr, "yyyyMMdd").isValid
        ? dayStr >= lastApproveDay
          ? 1
          : 0
        : -1
      : dayStr && DateTime.fromFormat(dayStr, "yyyyMMdd").isValid
      ? 1
      : -1;
}

// 作成日付(旧承認日)
let approveDay: string | null = "";
export function getApproveDay() {
  return approveDay;
}
export function setApproveDay(dayStr: string | null) {
  approveDay =
    dayStr && DateTime.fromFormat(dayStr, "yyyyMMdd").isValid ? dayStr : "";
}

// 最初の読み込み時に追い越しが走らないようにするためのフラグ
let initailizeFlag: boolean;

const KeieiShindanTable: FC<{
  tenpoCode: string;
  keieiShindanId: string;
  lastKeieiShindanId: string;
}> = ({ tenpoCode, keieiShindanId, lastKeieiShindanId }) => {
  const classes = useStyles();
  const user = useSelector(selectUser);
  const [click, setClick] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState<any[]>([]);

  const [rowItemList, setRowItemList] = React.useState<any[]>([]);

  const [open, setOpen] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);

  const [save, setSave] = React.useState(false);
  const [employee, setEmployee] = React.useState("");
  const [earlyMorningContact, setEarlyMorningContact] = React.useState("");
  const [morningContact, setMorningContact] = React.useState("");
  const [afternoonContact, setAfternoonContact] = React.useState("");
  const [eveningContact, setEveningContact] = React.useState("");
  const [lateNightContact, setLateNightContact] = React.useState("");
  const [lastEmployee, setLastEmployee] = React.useState("");
  const [lastEarlyMorningContact, setLastEarlyMorningContact] =
    React.useState("");
  const [lastMorningContact, setLastMorningContact] = React.useState("");
  const [lastAfternoonContact, setLastAfternoonContact] = React.useState("");
  const [lastEveningContact, setLastEveningContact] = React.useState("");
  const [lastLateNightContact, setLastLateNightContact] = React.useState("");
  const [lastTotalCount, setLastTotalCount] = React.useState("");

  const [approvalDate, setApprovalDate] = React.useState<DateTime | null>(null);
  const [convertedApprovalDate, setConvertedApprovalDate] = React.useState<
    string | null
  >(null);
  const [lastApprovalDate, setLastApprovalDate] = React.useState("");
  const [lastDateTitle, setLastDateTitle] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [userPrivilege, setUserPrivilege] = React.useState("");
  const [dmComment, setDmComment] = React.useState("");
  const [dmCommentUser, setDmCommentUser] = React.useState("");
  const [acquiredTenpoCheckRecordId, setAcquiredTenpoCheckRecordId] =
    React.useState("");
  const [acquiredOneVisionRecordId, setAcquiredOneVisionRecordId] =
    React.useState("");
  const [acquiredTsCheckRecordId, setAcquiredTsCheckRecordId] =
    React.useState("");

  useEffect(() => {
    setRowItemList([]);
    setApprovalDate(null);
    setConvertedApprovalDate("");
    setApproveDay("");
    setChangeFlg(false);
    initailizeFlag = false;
  }, [tenpoCode, getFirstFlg()]);

  // 自動取得項目を更新する
  const getAutoItemScore: any = async (rowItemList: any[], otherData: any) => {
    setLoading(true);
    const apiParams = {
      tenpo_code: tenpoCode,
      jobCategory: getJobCategoryFromCode(user),
    };
    const url =
      process.env.REACT_APP_API_URL_J11SPB22 + "keieishindan/score-linkage";
    await postRequest(url, apiParams)
      .then((res) => {
        setLoading(false);
        let scoreMap: any = {};
        // let linkageResult: any = {};
        let idChangeFlg = false;
        let initFlg = false;
        let dataList: any[] =
          res.data && res.data.dataList ? res.data.dataList : [];
        let noUpdate = false;
        if (dataList) {
          for (let getData of dataList) {
            if (getData.id) {
              let acqTenpoCheckId = getData.id.tenpo_check_records || "";
              let acqOnevisionId = getData.id.one_vision_records || "";
              let acqTsCheckId = getData.id.ts_check_records || "";

              let acquiredTenpoCheckId =
                otherData.acquired_tenpo_check_record_id;
              let acquiredOnevisionId = otherData.acquired_one_vision_record_id;
              let acquiredTsCheckId = otherData.acquired_ts_check_record_id;
              if (
                !acquiredTenpoCheckId &&
                !acquiredOnevisionId &&
                !acquiredTsCheckId
              ) {
                initFlg = true;
              }
              if (
                acqTenpoCheckId === acquiredTenpoCheckId &&
                acqOnevisionId === acquiredOnevisionId &&
                acqTsCheckId === acquiredTsCheckId
              ) {
                setAcquiredTenpoCheckRecordId(acquiredTenpoCheckId);
                setAcquiredOneVisionRecordId(acquiredOnevisionId);
                setAcquiredTsCheckRecordId(acquiredTsCheckId);
                setRowItemList(rowItemList);
                setLoading(false);
                noUpdate = true;
                // return;
              } else {
                setAcquiredTenpoCheckRecordId(acqTenpoCheckId);
                setAcquiredOneVisionRecordId(acqOnevisionId);
                setAcquiredTsCheckRecordId(acqTsCheckId);
                setChangeFlg(true);
                idChangeFlg = true;
              }
            }
            if (getData.scores) {
              scoreMap = getData.scores;
            }
          }
        }

        if (!noUpdate) {
          for (let workRowItem of rowItemList) {
            for (let rows of workRowItem.rows) {
              let existItemFlg = false;
              let getScoreFlg = false;
              if (rows.small_item_type) {
                existItemFlg = true;
              }

              if (rows.small_item_type && scoreMap) {
                Object.keys(scoreMap)
                  .sort()
                  .forEach(function (key: any) {
                    if (rows.small_item_type === key) {
                      if (scoreMap[key] || scoreMap[key] === "0") {
                        getScoreFlg = true;
                      }
                      rows.score = scoreMap[key];
                      rows.button_value = scoreMap[key];
                      return;
                    }
                  });
              }
              if (existItemFlg && !getScoreFlg) {
                // 取得できない場合、仮で0を入れる
                rows.score = "0";
                rows.button_value = "0";
              }
            }
          }
        }

        setRowItemList(rowItemList);
        setClick(!click);

        if (!initFlg && idChangeFlg) {
          let messages = [];
          messages.push(
            "最新のデータを取得しています、再度「保存」を選択してください。"
          );
          setErrorMessage(messages);
          setOpen(true);
          setChangeFlg(true);
          return;
        }
      })
      .catch((e) => {
        setRowItemList(rowItemList);
        setChangeFlg(false);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (loading === true || !keieiShindanId) {
      setRowItemList([]);
      setApprovalDate(null);
      // saveApprovalDate = null;
      setChangeFlg(false);
      initailizeFlag = false;
      // setSelectedTenpoCode("");
      return;
    }
    setLoading(true);
    userLogging("経営診断確認", "新規作成#初期表示", keieiShindanId);
    setUserPrivilege(getJobCategoryFromCode(user));
    setRowItemList([]);
    initailizeFlag = false;
    setApprovalDate(null);
    setConvertedApprovalDate("");
    setApproveDay(convertedApprovalDate);

    getKeieiShindanData(tenpoCode, keieiShindanId, lastKeieiShindanId).then(
      (res: any) => {
        setApprovalDate(
          res.approve_day
            ? DateTime.fromFormat(res.approve_day, "yyyyMMdd")
            : null
        );
        checkApproveDate(
          res.approve_day ? res.approve_day : "",
          res.last_approve_day
        );
        setConvertedApprovalDate(res.approve_day);
        setApproveDay(res.approve_day);

        setRowItemList(rowItemList);

        // setRowItemList(res.rows);
        setLastApprovalDate(res.last_approve_day);

        setLastDateTitle(
          res.last_approve_day
            ? DateTime.fromFormat(res.last_approve_day, "yyyyMMdd").toFormat(
                "MM月dd日"
              )
            : "-"
        );
        const others = res.other_data;
        setDmComment(others.dm_comment || "");
        setDmCommentUser(others.dm_comment_user || "");
        setEmployee(others.employee);
        setEarlyMorningContact(others.early_morning_contact);
        setMorningContact(others.morning_contact);
        setAfternoonContact(others.afternoon_contact);
        setEveningContact(others.evening_contact);
        setLateNightContact(others.late_night_contact);
        setLastEmployee(others.last_employee);
        setLastEarlyMorningContact(others.last_early_morning_contact);
        setLastMorningContact(others.last_morning_contact);
        setLastAfternoonContact(others.last_afternoon_contact);
        setLastEveningContact(others.last_evening_contact);
        setLastLateNightContact(others.last_late_night_contact);
        setLastTotalCount(others.last_total_count || 0);

        if (!getFixedFlg()) {
          getAutoItemScore(res.rows, others);
        } else {
          setRowItemList(res.rows);
          setLoading(false);
          setClick(!click);
        }
        initailizeFlag = true;
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keieiShindanId]);

  const handleClick = () => {
    setClick((prev) => !click);
  };
  const handleSave = () => {
    setSave((prev) => !save);
  };

  const handleApprovalDate = (date: DateTime | null) => {
    if (!initailizeFlag) return date;
    setChangeFlg(true);
    checkApproveDate(date ? date.toFormat("yyyyMMdd") : "", lastApprovalDate);
    setConvertedApprovalDate(date ? date.toFormat("yyyyMMdd") : "");
    setApproveDay(date ? date.toFormat("yyyyMMdd") : "");
    setApprovalDate(date);
    handleSave();
    return date;
  };

  const blurEmployee = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setEmployee(people);
  };
  const blurEarly = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setEarlyMorningContact(people);
  };

  const blurMorning = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setMorningContact(people);
  };
  const blurAfternoon = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setAfternoonContact(people);
  };
  const blurEvening = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setEveningContact(people);
  };
  const blurNight = (people: string, changed: boolean) => {
    if (changed) {
      setChangeFlg(true);
    }
    setLateNightContact(people);
  };

  const initApproveDate = () => {
    checkApproveDate(
      approvalDate ? approvalDate.toFormat("yyyyMMdd") : "",
      lastApprovalDate
    );
    if (approvalDate !== null) return approvalDate;
    let date = DateTime.local();
    setChangeFlg(true);
    setConvertedApprovalDate(date ? date.toFormat("yyyyMMdd") : "");
    setApproveDay(date ? date.toFormat("yyyyMMdd") : "");
    setApprovalDate(date);
    return approvalDate;
  };

  const doSelChange = (
    row: any,
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    row.score =
      event.target.value || event.target.value === 0
        ? (event.target.value as string)
        : "";
    setChangeFlg(true);
    handleClick();
  };

  // ボタン押下処理
  const clickButton = (row: any, n: number) => {
    if (getFixedFlg()) return;

    setChangeFlg(true);
    row.button_value = n;
    if (n === 2) {
      row.score = "-5";
    } else {
      row.score = "0";
    }
    handleClick();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const alertClick = () => {
    setOpenAlert(!openAlert);
  };

  function zenkakuReplace(str: string) {
    return str.replace(/[０-９．]/g, function (s: string) {
      let result = String.fromCharCode(s.charCodeAt(0) - 0xfee0);
      return result;
    });
  }

  // 人数入力フィールド
  const InputPeopleField: React.FC<{
    people: string;
    blurEvent: (people: string, changeFlg: boolean) => void;
    fixedFlg: boolean;
  }> = ({ people, blurEvent, fixedFlg }) => {
    const [inputPeople, setInputPeople] = React.useState(people);
    const [inputChangeFlg, setInputChangeFlg] = React.useState(false);
    const maxInt = 99999999999999;
    const minInt = 0;
    const changePeople = (event: React.ChangeEvent<{ value: unknown }>) => {
      let val = zenkakuReplace(event.target.value as string);
      if (!val) {
        setInputPeople("");
        setInputChangeFlg(true);
        return;
      }
      if (!Number(val) && Number(val) !== 0) {
        setInputPeople("");
        setInputChangeFlg(true);
        return;
      }
      let changedPeople: any = Number(val);
      if (changedPeople >= maxInt) {
        changedPeople = maxInt;
      }
      if (changedPeople <= minInt) {
        changedPeople = minInt;
      }
      setInputChangeFlg(true);
      setInputPeople(changedPeople);
    };
    const blurPeople = () => {
      blurEvent(inputPeople, inputChangeFlg);
    };

    return (
      <OutlinedInput
        type="text"
        endAdornment="人"
        value={inputPeople}
        onChange={(e) => changePeople(e)}
        onBlur={() => blurPeople()}
        disabled={fixedFlg}
      ></OutlinedInput>
    );
  };

  // 画面スクロール
  const moveScroll = (fieldName: string, bottomFlg?: boolean) => {
    let element = document?.getElementById(fieldName);
    if (element !== null) {
      if (bottomFlg) {
        element?.scrollIntoView(false);
      } else {
        element.scrollIntoView();
      }
    }
  };

  // 保存ボタンクリック処理
  const clickConfirmButton = async () => {
    userLogging("KeieiShindan", "新規作成#保存ボタン", "");

    if (getFixedFlg()) return;

    // 既に完了している場合は更新しない
    const KeieiShindanData: any = await getKeieiShindanRecordsFirestoreData(
      keieiShindanId
    );
    if (KeieiShindanData && KeieiShindanData.attribution.complete_date) return;

    let totalCount =
      Number(morningContact) +
      Number(earlyMorningContact) +
      Number(afternoonContact) +
      Number(eveningContact) +
      Number(lateNightContact);

    if (!rowItemList || !initailizeFlag) return;
    let others: KEIEI_SHINDAN_OTHER_DATA = {
      dm_comment: dmComment || "",
      dm_comment_user: dmCommentUser || "",
      employee: employee ? Number(employee) : String(employee) === "0" ? 0 : "",
      early_morning_contact: earlyMorningContact
        ? Number(earlyMorningContact)
        : String(earlyMorningContact) === "0"
        ? 0
        : "",
      morning_contact: morningContact
        ? Number(morningContact)
        : String(morningContact) === "0"
        ? 0
        : "",
      afternoon_contact: afternoonContact
        ? Number(afternoonContact)
        : String(afternoonContact) === "0"
        ? 0
        : "",
      evening_contact: eveningContact
        ? Number(eveningContact)
        : String(eveningContact) === "0"
        ? 0
        : "",
      late_night_contact: lateNightContact
        ? Number(lateNightContact)
        : String(lateNightContact) === "0"
        ? 0
        : "",
      total_count: String(totalCount),
      last_employee: lastEmployee || "",
      last_morning_contact: lastMorningContact || "",
      last_early_morning_contact: lastEarlyMorningContact || "",
      last_afternoon_contact: lastAfternoonContact || "",
      last_evening_contact: lastEveningContact || "",
      last_late_night_contact: lastLateNightContact || "",
      last_total_count: lastTotalCount || "",
      acquired_tenpo_check_record_id: acquiredTenpoCheckRecordId || "",
      acquired_one_vision_record_id: acquiredOneVisionRecordId || "",
      acquired_ts_check_record_id: acquiredTsCheckRecordId || "",
    };
    updateKeieiShindanFirestore(
      rowItemList,
      keieiShindanId,
      lastKeieiShindanId,
      tenpoCode,
      others,
      convertedApprovalDate || "",
      lastApprovalDate || "",
      userPrivilege
    );

    //保存処理
    setChangeFlg(false);
    handleSave();
    handleClick();
  };

  // 各項目
  function getCheckRecord(rowItem: any, index: number) {
    return (
      <>
        {Object.keys(rowItem.rows).length !== 0 ? (
          <>
            {/* 大項目名↓ここから */}
            <Grid container justify="center" className={classes.header}>
              <Grid container justify="center">
                <Typography variant="h4">{rowItem.big_title}</Typography>
                <Typography variant="h6">
                  {rowItem.big_item_id === "6" ? "※×の場合-5点" : ""}
                </Typography>
              </Grid>
            </Grid>
            {/* 大項目名↑ここまで */}
            <Grid container className={classes.tabBase}>
              {/* タイトル行↓ここから */}
              <Grid container>
                <Grid
                  item
                  md={rowItem.big_item_id === "6" ? 9 : 10}
                  sm={rowItem.big_item_id === "6" ? 8 : 9}
                  className={classes.columnHeader}
                >
                  <Grid
                    container
                    className={classes.headerHeight}
                    justify="center"
                    alignItems="center"
                  >
                    <Typography variant="h6">チェック項目</Typography>
                  </Grid>
                </Grid>
                <Grid item xs={1} className={classes.columnHeader}>
                  <Grid
                    container
                    className={classes.headerHeight}
                    justify="center"
                    alignItems="center"
                  >
                    <Typography variant="h6">前回</Typography>
                  </Grid>
                </Grid>
                <Grid item xs className={classes.columnHeader}>
                  <Grid
                    container
                    className={classes.headerHeight}
                    justify="center"
                    alignItems="center"
                  >
                    <Typography variant="h6">
                      {rowItem.big_item_id === "6" ? "今回" : "点数"}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* タイトル行↑ここまで */}

              {/* データ行↓ここから */}
              <Grid container>
                {rowItem.rows.map((row: any, indexRowItem: number) =>
                  row.big_item_id === 6 ? (
                    <>
                      <Grid container>
                        <Grid
                          item
                          md={9}
                          sm={8}
                          className={classes.columnResult}
                        >
                          <Grid
                            container
                            className={classes.columnHeight}
                            alignItems="center"
                          >
                            {row.small_title1}
                            {row.small_title2}
                          </Grid>
                        </Grid>
                        <Grid item xs={1} className={classes.columnResult}>
                          <Grid
                            container
                            className={classes.columnHeight}
                            justify="center"
                            alignItems="center"
                          >
                            {row.last_score === "0" ? (
                              <RadioButtonUnchecked />
                            ) : row.last_score === "-5" ? (
                              <CloseIcon />
                            ) : (
                              ""
                            )}
                          </Grid>
                        </Grid>
                        <Grid item xs className={classes.columnData}>
                          <Grid container>
                            <Grid item xs={6} alignItems="center">
                              <Grid
                                container
                                className={classes.columnHeight}
                                justify="center"
                                alignItems="center"
                              >
                                <Avatar
                                  className={
                                    classes.gray +
                                    " " +
                                    (row.button_value === 1 ? classes.mark : "")
                                  }
                                  onClick={() => console.log("a1")}
                                >
                                  <IconButton
                                    onClick={() => clickButton(row, 1)}
                                  >
                                    <RadioButtonUnchecked />
                                  </IconButton>
                                </Avatar>
                              </Grid>
                            </Grid>
                            <Grid item xs={6}>
                              <Grid
                                container
                                className={classes.columnHeight}
                                justify="center"
                                alignItems="center"
                              >
                                <Avatar
                                  className={
                                    classes.gray +
                                    " " +
                                    (row.button_value === 2
                                      ? classes.ngMark
                                      : "")
                                  }
                                  onClick={() => console.log("a1")}
                                >
                                  <IconButton
                                    onClick={() => clickButton(row, 2)}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Avatar>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  ) : (
                    <>
                      {/* チェック項目↓ここから */}
                      <Grid
                        container
                        className={
                          row.small_item_type && row.small_item_type.length > 1
                            ? classes.autoColumnResult
                            : classes.columnResult
                        }
                        key={row.key + "_caption_A"}
                        md={10}
                        sm={9}
                      >
                        <Grid item xs>
                          <KeieiShindanModalManual
                            title={
                              (row.small_item_no ? row.small_item_no : "") +
                              row.small_title1
                            }
                            title2={row.small_title2}
                            filePath={row.photo_filepath_gcs}
                            infoMessage={row.small_info_message}
                          />
                        </Grid>
                      </Grid>
                      {/* チェック項目↑ここまで */}

                      {/* 前回↓ここから */}
                      <Grid
                        container
                        xs={1}
                        className={
                          classes.columnHeight +
                          " " +
                          (row.small_item_type && row.small_item_type.length > 1
                            ? classes.autoColumnResult
                            : classes.columnResult)
                        }
                        justify="center"
                        alignItems="center"
                      >
                        {row.last_score}
                      </Grid>
                      {/* 前回↑ここまで */}

                      {/* 点数入力↓ここから */}
                      <Grid
                        container
                        xs
                        className={
                          classes.columnData + " " + classes.columnHeight
                        }
                        justify="center"
                        alignItems="center"
                      >
                        <Select
                          value={row.score}
                          onChange={(event) => doSelChange(row, event)}
                          readOnly={getFixedFlg()}
                        >
                          {row.score_list.map((evl: any) => (
                            <MenuItem value={evl}>{evl}</MenuItem>
                          ))}
                        </Select>
                      </Grid>
                      {/* 点数入力↑ここまで */}
                    </>
                  )
                )}
              </Grid>
              {/* データ行↑ここまで */}
            </Grid>
          </>
        ) : (
          ""
        )}
      </>
    );
  }

  return (
    <>
      {/* メインコンテンツ↓ここから */}
      {(loading || getReadFixedFlg()) && (
          <div className={classes.overLayer}></div>
        )}
        {(loading || getReadFixedFlg()) && (
          <CircularProgress className={classes.circularProgress} size={120} />
      )}
      {rowItemList && rowItemList.length > 0 ? (
        <>
          <Grid container className={classes.contentFrame}>
            <Grid id="topField" />
            {/* 作成日↓ここから */}
            <Grid container>
              <Grid item lg={9} md={8} sm={8}>
                <Grid container justify="flex-end" alignItems="center">
                  <Typography variant="h6">作成日</Typography>
                </Grid>
              </Grid>
              <Grid item lg={3} md={4} sm={4}>
                <Grid container justify="center" alignItems="center">
                  {getFixedFlg() ? (
                    approvalDate ? (
                      <Typography variant="h6">
                        {approvalDate.toFormat("yyyy/MM/dd") +
                          "(" +
                          getDayOfWeekText(approvalDate) +
                          ")"}
                      </Typography>
                    ) : (
                      ""
                    )
                  ) : (
                    <DatePicker
                      selectedDate={initApproveDate()}
                      dateFunc={(date: DateTime | null) => {
                        handleApprovalDate(date);
                      }}
                      format={
                        "yyyy年MM月dd日" +
                        "(" +
                        getDayOfWeekText(approvalDate) +
                        ")"
                      }
                      minDate={DateTime.fromFormat(
                        lastApprovalDate,
                        "yyyyMMdd"
                      )}
                      mainColor={"#4dc0b2"}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item lg={9} md={8} sm={8}>
                <Grid container justify="flex-end" alignItems="center">
                  <Typography variant="h6">前回作成日</Typography>
                </Grid>
              </Grid>
              <Grid item lg={3} md={4} sm={4}>
                <Grid container justify="center" alignItems="center">
                  <Typography variant="h6">{lastDateTitle}</Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* 作成日↑ここまで */}
            {/* チェック表↓ここから */}
            <Grid container justify="center">
              {/* 項目 */}
              {rowItemList.map((rowItem, index) =>
                getCheckRecord(rowItem, index)
              )}
            </Grid>
            {/* チェック表↑ここまで */}

            <Grid container style={{ height: "30px" }}></Grid>

            <Grid container justify="center">
              <Grid container justify="center">
                <Grid item>
                  <Typography variant="h6">声掛け人数</Typography>
                </Grid>
                <Grid item>
                  <KeieiShindanModalManual
                    title={""}
                    title2={""}
                    filePath={["keiei-shindan-manual/info_koekake.png"]}
                    infoMessage={[]}
                  />
                </Grid>
              </Grid>
              <Grid container>
                {/* 前回 */}
                <Grid item xs={6}>
                  <Table>
                    <TableRow>
                      <TableCell colSpan={3} style={{ border: "0" }} />
                      <TableCell
                        colSpan={2}
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        前回従業員人数
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={3} style={{ border: "0" }} />
                      <TableCell
                        className={classes.inputTableCell}
                        colSpan={2}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastEmployee}人
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        早朝
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        午前
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        午後
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        夕方
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        深夜
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastMorningContact}人
                        </Typography>
                      </TableCell>
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastEarlyMorningContact}人
                        </Typography>
                      </TableCell>
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastAfternoonContact}人
                        </Typography>
                      </TableCell>
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastEveningContact}人
                        </Typography>
                      </TableCell>
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastLateNightContact}人
                        </Typography>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} style={{ border: "0" }} />
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        合計
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} style={{ border: "0" }} />
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {lastTotalCount}人
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>

                <Grid item style={{ paddingRight: "10px" }}></Grid>
                {/* 今回 */}
                <Grid item xs>
                  <Table>
                    <TableRow>
                      <TableCell colSpan={3} style={{ border: "0" }} />
                      <TableCell
                        colSpan={2}
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        従業員人数
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={3} style={{ border: "0" }} />
                      <TableCell
                        className={classes.inputTableCell}
                        colSpan={2}
                        style={{ textAlign: "right" }}
                      >
                        <InputPeopleField
                          people={employee}
                          blurEvent={blurEmployee}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        早朝
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        午前
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        午後
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        夕方
                      </TableCell>
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        深夜
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.inputTableCell}>
                        <InputPeopleField
                          people={earlyMorningContact}
                          blurEvent={blurEarly}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                      <TableCell className={classes.inputTableCell}>
                        <InputPeopleField
                          people={morningContact}
                          blurEvent={blurMorning}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                      <TableCell className={classes.inputTableCell}>
                        <InputPeopleField
                          people={afternoonContact}
                          blurEvent={blurAfternoon}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                      <TableCell className={classes.inputTableCell}>
                        <InputPeopleField
                          people={eveningContact}
                          blurEvent={blurEvening}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                      <TableCell className={classes.inputTableCell}>
                        <InputPeopleField
                          people={lateNightContact}
                          blurEvent={blurNight}
                          fixedFlg={getFixedFlg()}
                        />
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} style={{ border: "0" }} />
                      <TableCell
                        className={
                          classes.tableCell + " " + classes.tableHeader
                        }
                      >
                        合計
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell colSpan={4} style={{ border: "0" }} />
                      <TableCell
                        className={classes.inputTableCell}
                        style={{ textAlign: "right" }}
                      >
                        <Typography variant="inherit">
                          {Number(
                            Number(morningContact) +
                              Number(earlyMorningContact) +
                              Number(afternoonContact) +
                              Number(eveningContact) +
                              Number(lateNightContact)
                          ) || 0}
                          人
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </Table>
                </Grid>
              </Grid>
            </Grid>
            <Grid id="bottomField" />
          </Grid>
          {/* コンテンツフッター↓ここから */}
          <Grid
            container
            justify="flex-end"
            alignItems="center"
            className={classes.footer}
          >
            <IconButton
              className={classes.upDownButton}
              style={{ color: "#ffffff", backgroundColor: "#00CC5B" }}
              onClick={() => moveScroll("topField")}
            >
              <VerticalAlignTop></VerticalAlignTop>
            </IconButton>
            <IconButton
              className={classes.upDownButton}
              style={{ color: "#ffffff", backgroundColor: "#00CC5B" }}
              onClick={() => moveScroll("bottomField")}
            >
              <VerticalAlignBottom></VerticalAlignBottom>
            </IconButton>
            {getFixedFlg() ? (
              ""
            ) : (
              <>
                <Button
                  variant={"contained"}
                  color={changeFlg ? "secondary" : "primary"}
                  onClick={() => {
                    clickConfirmButton();
                    alertClick();
                  }}
                >
                  保存
                </Button>
                <Snackbar
                  open={openAlert}
                  autoHideDuration={5000}
                  onClose={alertClick}
                >
                  <SnackbarContent
                    style={{ backgroundColor: "#333333", color: "white" }}
                    message={
                      <span style={{ fontSize: "16px" }}>
                        {
                          "提出（印刷）タブをクリックして店舗経営診断を提出してください。"
                        }
                      </span>
                    }
                  />
                </Snackbar>
              </>
            )}
          </Grid>
          {/* コンテンツフッター↑ここまで */}
        </>
      ) : (
        ""
      )}
      {/* 入力エラーダイアログ↓ここから */}
      <KeieiShindanDialog
        msg={errorMessage}
        isOpen={open}
        doOK={handleClose}
        doNo={handleClose}
        isAlert={true}
        isClose={true}
      />
      {/* 入力エラーダイアログここまで */}
    </>
  );
};
export default KeieiShindanTable;